import { Component } from '@angular/core';

@Component({
  selector: 'app-solutions-redesign',
  templateUrl: './solutions-redesign.component.html',
  styleUrls: ['./solutions-redesign.component.scss']
})
export class SolutionsRedesignComponent {

}
